function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { defineComponent, $prefix, $props, $setup } from "@opentiny/vue-common";
import PcTemplate from "./pc.js";
import MobileFirstTemplate from "./mobile-first.js";
import "@opentiny/vue-theme/image/index.css";
var template = function template2(mode) {
  if ("pc" === (process.env.TINY_MODE || mode)) {
    return PcTemplate;
  }
  if ("mobile-first" === (process.env.TINY_MODE || mode)) {
    return MobileFirstTemplate;
  }
  return PcTemplate;
};
var $constants = {
  NONE: "none",
  CONTAIN: "contain",
  COVER: "cover",
  FILL: "fill",
  SCALE_DOWN: "scale-down",
  DEFAULT_POPPER_ZINDEX: Number.POSITIVE_INFINITY
};
var Image = defineComponent({
  name: $prefix + "Image",
  props: _extends({}, $props, {
    _constants: {
      type: Object,
      default: function _default() {
        return $constants;
      }
    },
    fit: String,
    lazy: Boolean,
    previewSrcList: {
      type: Array,
      default: function _default2() {
        return [];
      }
    },
    scrollContainer: {},
    src: String,
    zIndex: {
      type: Number,
      default: $constants.DEFAULT_POPPER_ZINDEX
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    showHover: {
      type: Boolean,
      default: false
    },
    previewVisible: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    imageSize: {
      type: Number,
      default: 100
    }
  }),
  setup: function setup(props, context) {
    return $setup({
      props,
      context,
      template
    });
  }
});
var version = "2.10.0";
Image.install = function(Vue) {
  Vue.component(Image.name, Image);
};
Image.version = version;
export {
  Image as default
};
